import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

const wurzel = document.getElementById('root');
if (!wurzel) {
  throw new Error('Das Wurzelelement #root fehlt in index.html.');
}

createRoot(wurzel).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
